/**
 * Loading Skeleton for Login Page
 *
 * Matches the modern 2025 minimal LoginPage design
 */
export function LoginSkeleton() {
  return (
    <div className='absolute inset-0 flex items-center justify-center px-4'>
      <div className='w-full max-w-md space-y-6'>
        {/* Header Skeleton */}
        <div className='text-center space-y-2'>
          <div className='h-9 bg-muted/30 rounded-lg w-48 mx-auto animate-pulse' />
          <div className='h-5 bg-muted/20 rounded w-64 mx-auto animate-pulse' />
        </div>

        {/* Form Card Skeleton - Clean design */}
        <div className='bg-white rounded-2xl shadow-lg border border-border/50 p-6 sm:p-8 space-y-6'>
          <div className='space-y-4'>
            {/* Email Field Skeleton */}
            <div className='space-y-1.5'>
              <div className='h-5 bg-muted/30 rounded w-12 animate-pulse' />
              <div className='h-10 bg-muted/20 rounded-lg w-full animate-pulse' />
            </div>

            {/* Password Field Skeleton */}
            <div className='space-y-1.5'>
              <div className='flex justify-between items-center'>
                <div className='h-5 bg-muted/30 rounded w-16 animate-pulse' />
                <div className='h-4 bg-muted/30 rounded w-14 animate-pulse' />
              </div>
              <div className='h-10 bg-muted/20 rounded-lg w-full animate-pulse' />
            </div>

            {/* Submit Button Skeleton */}
            <div className='pt-2'>
              <div className='h-10 bg-gradient-primary from-navy/80 to-royal-blue/80 rounded-lg w-full animate-pulse' />
            </div>
          </div>

          {/* Divider */}
          <div className='relative my-6'>
            <div className='absolute inset-0 flex items-center'>
              <div className='w-full border-t border-border' />
            </div>
            <div className='relative flex justify-center'>
              <div className='h-4 bg-white px-2'>
                <div className='h-3 bg-muted/30 rounded w-8 animate-pulse' />
              </div>
            </div>
          </div>

          {/* Sign Up Link Skeleton */}
          <div className='text-center'>
            <div className='h-5 bg-muted/20 rounded w-48 mx-auto animate-pulse' />
          </div>
        </div>

        {/* Footer Skeleton */}
        <div className='text-center'>
          <div className='h-4 bg-muted/20 rounded w-64 mx-auto animate-pulse' />
        </div>
      </div>
    </div>
  )
}
